import type { Block } from '@sanity/block-content-to-react';

export const blockContentToString = (
  blocks: Block[] | null | undefined,
): string => {
  if (!blocks) return '';

  return blocks.reduce((final: string, current: Block) => {
    if (!current.children) return final;
    const blockText = current.children.reduce(
      (final: string, { text }: { text: string }) => `${final} ${text}`,
      '',
    );

    return `${final}\n${blockText}`;
  }, '');
};
